import {AuthProvider, fetchUtils} from 'react-admin';
import {ADMIN_AUTH_URL} from "../../constants/api-url";


const baseUrl = ADMIN_AUTH_URL;

const httpJson = fetchUtils.fetchJson;

export const authProvider: AuthProvider = {
  login: async ({ username, password }) => {
    console.log(baseUrl, username)
    const { json } = await httpJson(`${baseUrl}/login`, {
      method: 'POST',
      body: JSON.stringify({ email: username, password }),
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
    // expect { accessToken: string, user?: {...} }
    if (!json?.accessToken) throw new Error('Invalid login response');
    localStorage.setItem('admin_token', json.accessToken);
    if (json.user) localStorage.setItem('admin_user', JSON.stringify(json.user));
  },

  // Called when user clicks logout
  logout: async () => {
    const token = localStorage.getItem('admin_token');
    // optional server revoke
    try {
      if (token) {
        await httpJson(`${baseUrl}/logout`, {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          }),
        });
      }
    } catch {
      // ignore server errors on logout
    }
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    return Promise.resolve();
  },

  // Called when API returns an error
  checkError: ({ status }) => {
    if (status === 401 || status === 403) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
      return Promise.reject();
    }
    return Promise.resolve();
  },

  // Called on navigation or refresh to check if user is authenticated
  checkAuth: () => {
    return localStorage.getItem('admin_token') ? Promise.resolve() : Promise.reject();
  },

  // Optional: used by <UserMenu> etc.
  getIdentity: async () => {
    const user = localStorage.getItem('admin_user');
    if (user) {
      const parsed = JSON.parse(user);
      return { id: parsed.id ?? 'me', fullName: parsed.name ?? parsed.email };
    }
    return { id: 'me', fullName: 'Admin' };
  },

  // Optional: role-based auth
  getPermissions: () => Promise.resolve(undefined),
};
